import * as Yup from 'yup';

export const aramexInformationSchema = Yup.object().shape({
  type: Yup.string().required('Type is required'),
  accountNo: Yup.mixed()
    .test('is-valid', 'Account is required', (value: any) => {
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === 'object') return true;
      return !!value;
    })
    .required('Account is required'),
  countryOfManufacture: Yup.string().trim().required('Country of manufacture is required'),
  shipperTaxId: Yup.string().trim().required('Shipper Tax ID is required'),
  invoiceDate: Yup.date().required('Invoice Date is required').nullable(),
  productType: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Product type is required'),
  paymentType: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Payment type is required'),
  invoiceNumber: Yup.string().trim().required('Invoice number is required'),
  ShipmentType: Yup.string().required('Shipment type is required'),
  WhetherSupplyforExportIsOnPaymentOfIGST: Yup.string().when('ShipmentType', ([shipmentType], schema) => {
    return shipmentType === 'CSBV' ? schema.required('This field is required') : schema;
  }),
  WhetherAgainstBondOrUT: Yup.string().when('ShipmentType', ([shipmentType], schema) => {
    return shipmentType === 'CSBV' ? schema.required('This field is required') : schema;
  }),
  TermsOfTrade: Yup.string().when('ShipmentType', ([shipmentType], schema) => {
    return shipmentType === 'CSBV' ? schema.required('Terms of trade is required') : schema;
  }),
  WhetherMEIS: Yup.string().when('ShipmentType', ([shipmentType], schema) => {
    return shipmentType === 'CSBV' ? schema.required('This field is required') : schema;
  }),
  IGSTRate: Yup.number()
    .nullable()
    .when('WhetherSupplyforExportIsOnPaymentOfIGST', ([value], schema) => {
      return value === 'YES'
        ? schema.required('IGST Rate is required when Supply for Export is on payment of IGST')
        : schema;
    }),

  IGSTAmount: Yup.number()
    .nullable()
    .when('WhetherSupplyforExportIsOnPaymentOfIGST', ([value], schema) => {
      return value === 'YES'
        ? schema.required('IGST Amount is required when Supply for Export is on payment of IGST')
        : schema;
    }),
  ADCode: Yup.string(),
  FreightAmount: Yup.number().nullable(),
  InsuranceAmount: Yup.number().nullable(),
  BillToName: Yup.string(),
  BillToAddress: Yup.string(),
  BillToCountryCode: Yup.string(),
  BankAccountNumber: Yup.string()
    .trim()
    .default('')
    .when('ShipmentType', ([value], schema) => {
      return value === 'CSBV' ? schema.required('Bank Account Number is required for CSBV shipment') : schema;
    }),

  GSTN: Yup.string()
    .trim()
    .when('ShipmentType', ([value], schema) => {
      return value === 'CSBV' ? schema.required('GSTN is required for CSBV shipment') : schema;
    }),

  IEC: Yup.string()
    .trim()
    .when('ShipmentType', ([value], schema) => {
      return value === 'CSBV' ? schema.required('IEC is required for CSBV shipment') : schema;
    }),
});
